import React, { useState, useEffect } from 'react';
import '../styles/SlidingVideos.css'; // Import the CSS file for styling
// import v1 from '../videos/Video1forcarousel.mp4';
import v2 from '../videos/Video2forcarousel.mp4';
import v3 from '../videos/Video3forcarousel.mp4';
import v4 from '../videos/Video4forcarousel.mp4';
import leftArrow from '../images/leftArrow.png';
import rightArrow from '../images/rightArrow.png';

const videos = [v2, v3, v4];

const SlidingVideos = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 5000); // Change video every 5 seconds

    return () => clearInterval(interval);
  }, [currentIndex]);

  const handleNext = () => {
    setIsAnimating(true);
    setTimeout(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === videos.length - 1 ? 0 : prevIndex + 1
      );
      setIsAnimating(false);
    }, 1000); // Duration of animation (1 second)
  };

  const handlePrev = () => {
    setIsAnimating(true);
    setTimeout(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === 0 ? videos.length - 1 : prevIndex - 1
      );
      setIsAnimating(false);
    }, 1000); // Duration of animation (1 second)
  };

  const handleDotClick = (index) => {
    setIsAnimating(true);
    setTimeout(() => {
      setCurrentIndex(index);
      setIsAnimating(false);
    }, 1000); // Duration of animation (1 second)
  };

  const getPrevIndex = () => (currentIndex === 0 ? videos.length - 1 : currentIndex - 1);
  const getNextIndex = () => (currentIndex === videos.length - 1 ? 0 : currentIndex + 1);

  return (
    <div className="sliding-content">
      <div className={`video-container ${isAnimating ? 'animating' : ''}`}>
        <video src={videos[getPrevIndex()]} muted loop className="video prev-video" />
        <video src={videos[currentIndex]} autoPlay muted loop className="video current-video" />
        <video src={videos[getNextIndex()]} muted loop className="video next-video" />
      </div>
      <div className="arrows-dots">
        <div className="prev-arrow" onClick={handlePrev}>
           <img src={leftArrow} alt="left arrow"  />
        </div>
        <div className="dots">
          {videos.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => handleDotClick(index)}
            ></span>
          ))}
        </div>
        <div className="next-arrow" onClick={handleNext}>
          <img src={rightArrow} alt="right arrow"/>
        </div>
      </div>
      <div className='getAnavu'>
        <a href="/signUp">
         <div className='getAnavu_text'>GET ANAVU</div>
        </a>
      </div>
    </div>
  );
}

export default SlidingVideos;
